import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useContext, useEffect, useState, memo, } from 'react';
import { Box, Typography, Autocomplete, } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Internal dependencies
import { UserContext } from '../auth';
import { TextFieldSG } from '../components';
import { getTools } from './constants';
import { workflowStyles } from './workflowStyles';
import { CustomPromptAction } from './CustomPromptAction';
/**
 * Custom Prompt Action component
 * @param props Props
 * @returns Custom Prompt Action component
 */
export const CustomToolAction = memo(function ({ action, actionIdx, actionErrors, actionTouched, setFieldValue, }) {
    var _a;
    // Get user credential
    const user = useContext(UserContext);
    // Get translation function
    const { t, i18n } = useTranslation();
    const TOOLS = getTools();
    const /** Tool options */ toolOptions = Object.values(TOOLS).map((tool) => ({ label: tool === null || tool === void 0 ? void 0 : tool.name, value: tool === null || tool === void 0 ? void 0 : tool.value }));
    const [toolOption, setToolOption] = useState({
        label: TOOLS.crawlWebpage.name,
        value: TOOLS.crawlWebpage.value,
    });
    useEffect(() => {
        var _a, _b;
        // Update tool when action has been loaded
        setToolOption({ label: (_a = TOOLS[action === null || action === void 0 ? void 0 : action.tool]) === null || _a === void 0 ? void 0 : _a.name, value: (_b = TOOLS[action === null || action === void 0 ? void 0 : action.tool]) === null || _b === void 0 ? void 0 : _b.value });
    }, [action]);
    return (_jsxs(Box, Object.assign({ sx: { width: '100%' } }, { children: [_jsx(Typography, Object.assign({ sx: Object.assign({}, workflowStyles.actionHeading1) }, { children: t('Tools').toUpperCase() })), _jsx(Autocomplete, { value: {
                    label: toolOption === null || toolOption === void 0 ? void 0 : toolOption.label,
                    value: toolOption === null || toolOption === void 0 ? void 0 : toolOption.value
                }, isOptionEqualToValue: (option, value) => (option.value === value.value), onChange: (event, value) => {
                    setToolOption(value);
                    setFieldValue(`actions[${actionIdx}].tool`, value === null || value === void 0 ? void 0 : value.value);
                }, options: toolOptions, disableClearable: true, sx: { width: '100%', '& input': Object.assign({}, workflowStyles.actionInput), }, renderInput: (params) => _jsx(TextFieldSG, Object.assign({ xstyles: { padding: '0', margin: '0 0 0.5rem' } }, params)) }), _jsx(Typography, Object.assign({ sx: Object.assign({}, workflowStyles.toolDescription) }, { children: (_a = TOOLS[toolOption === null || toolOption === void 0 ? void 0 : toolOption.value]) === null || _a === void 0 ? void 0 : _a.description })), _jsx(CustomPromptAction, { action: action, actionIdx: actionIdx, actionErrors: actionErrors, actionTouched: actionTouched, setFieldValue: setFieldValue })] })));
});
